import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "px-2",
  style: {"max-height":"calc(100vh - 3rem)","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_2 = {
  key: 0,
  class: "text-muted fs-7 p-3"
}
const _hoisted_3 = { class: "d-flex align-items-start justify-content-between mb-3" }
const _hoisted_4 = { class: "pe-3" }
const _hoisted_5 = {
  class: "fs-4 umt-drawer-title text-gray-900",
  style: {"font-weight":"700"}
}
const _hoisted_6 = { class: "text-muted fs-7" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "fw-semibold text-gray-700" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "fw-semibold text-gray-700" }
const _hoisted_11 = { class: "d-flex align-items-center gap-2 flex-shrink-0" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right me-1" }, null, -1)
const _hoisted_13 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_14 = { class: "d-flex flex-wrap gap-2 mb-5" }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-light-dark"
}
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope me-1" }, null, -1)
const _hoisted_18 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-3" }, "Thông tin hồ sơ", -1)
const _hoisted_20 = { class: "row g-3" }
const _hoisted_21 = { class: "col-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Mã hồ sơ", -1)
const _hoisted_23 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_24 = { class: "col-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Đợt", -1)
const _hoisted_26 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_27 = { class: "col-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phương thức", -1)
const _hoisted_29 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_30 = { class: "col-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Nguồn", -1)
const _hoisted_32 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_33 = { class: "col-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày tạo", -1)
const _hoisted_35 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_36 = {
  key: 0,
  class: "col-4"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Cập nhật", -1)
const _hoisted_38 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_39 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-3" }, "Ngành đăng ký", -1)
const _hoisted_41 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_42 = {
  key: 1,
  class: "d-flex flex-column gap-3"
}
const _hoisted_43 = {
  class: "badge badge-circle badge-light-primary me-2",
  title: "Ưu tiên"
}
const _hoisted_44 = { class: "flex-grow-1" }
const _hoisted_45 = { class: "d-flex justify-content-between align-items-center gap-2" }
const _hoisted_46 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_47 = {
  key: 0,
  class: "badge badge-light-success fs-8 text-nowrap",
  title: "Tổng điểm xét tuyển"
}
const _hoisted_48 = { class: "text-muted fs-8" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = {
  key: 3,
  class: "text-success fw-semibold"
}
const _hoisted_53 = {
  key: 2,
  class: "d-flex align-items-start"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle badge-light-primary me-2",
  title: "Ưu tiên"
}, "1", -1)
const _hoisted_55 = { class: "flex-grow-1" }
const _hoisted_56 = { class: "d-flex justify-content-between align-items-center gap-2" }
const _hoisted_57 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_58 = {
  key: 0,
  class: "badge badge-light-success fs-8 text-nowrap",
  title: "Điểm xét (hệ 10)"
}
const _hoisted_59 = { class: "text-muted fs-8" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_62 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded p-4 mb-4"
}
const _hoisted_63 = { class: "fw-bolder text-gray-800 mb-3 d-flex align-items-center justify-content-between" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", null, "Điểm xét tuyển", -1)
const _hoisted_65 = {
  key: 0,
  class: "badge badge-light-primary fs-8"
}
const _hoisted_66 = {
  key: 0,
  class: "d-flex align-items-start bg-light-danger border border-danger border-dashed rounded p-3 mb-3"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-semibold fs-8" }, [
  /*#__PURE__*/_createTextVNode("⚠ Phương pháp Học bạ không hợp lệ cho 2026 (chỉ nhận "),
  /*#__PURE__*/_createElementVNode("b", null, "9CR"),
  /*#__PURE__*/_createTextVNode(") — hồ sơ bị tính KHÔNG hợp lệ, cần chỉnh lại phương pháp xét tuyển.")
], -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = {
  key: 0,
  class: "text-gray-500 fs-8 fw-semibold text-uppercase mb-1"
}
const _hoisted_70 = { class: "row g-2" }
const _hoisted_71 = { class: "text-gray-600 fs-8" }
const _hoisted_72 = { class: "text-gray-900 fw-semibold fs-8 ms-2 text-end" }
const _hoisted_73 = {
  key: 2,
  class: "text-muted fs-8"
}
const _hoisted_74 = { class: "border border-gray-300 border-dashed rounded p-4 mb-2" }
const _hoisted_75 = { class: "fw-bolder text-gray-800 mb-3 d-flex align-items-center justify-content-between" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", null, "Salesforce", -1)
const _hoisted_77 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_78 = {
  key: 1,
  class: "badge badge-light-warning"
}
const _hoisted_79 = {
  key: 2,
  class: "badge badge-light-secondary"
}
const _hoisted_80 = {
  key: 0,
  class: "row g-2 mb-1"
}
const _hoisted_81 = {
  key: 0,
  class: "col-6"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Lead", -1)
const _hoisted_83 = ["href"]
const _hoisted_84 = {
  key: 1,
  class: "col-6"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Opportunity", -1)
const _hoisted_86 = ["href"]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_88 = { class: "row g-2" }
const _hoisted_89 = { class: "text-gray-600 fs-8" }
const _hoisted_90 = { class: "text-muted" }
const _hoisted_91 = { class: "text-gray-900 fw-semibold fs-8 text-break" }
const _hoisted_92 = {
  key: 1,
  class: "text-muted fs-8 mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.drawerVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.drawerVisible) = $event)),
    direction: "rtl",
    size: "500px",
    "with-header": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.drawerLoading && !_ctx.drawerRow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Đang tải…"))
          : _createCommentVNode("", true),
        (_ctx.drawerRow)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString((_ctx.dataCustomer && _ctx.dataCustomer.fullName) || 'Ứng viên'), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.dataCustomer && _ctx.dataCustomer.idCard)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          _createTextVNode("CCCD: "),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.dataCustomer.idCard), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.drawerRow.code)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                          _createTextVNode(" · Mã HS: "),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.drawerRow.code), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.adRegId)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/hosoungvien/${_ctx.adRegId}`,
                        class: "btn btn-sm btn-light-primary umt-btn-32",
                        title: "Mở trang chi tiết hồ sơ"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _createTextVNode("Chi tiết ")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: "btn btn-sm btn-icon btn-active-light-primary",
                    title: "Đóng",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawerVisible = false))
                  }, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", {
                  class: _normalizeClass(`badge badge-light-${_ctx.drawerRow.status?.state}`)
                }, _toDisplayString(_ctx.drawerRow.status?.label), 3),
                _createElementVNode("span", {
                  class: _normalizeClass(`badge badge-light-${_ctx.drawerRow.isActive ? 'success' : 'secondary'}`)
                }, _toDisplayString(_ctx.drawerRow.isActive ? 'Đang kích hoạt' : 'Đã tắt'), 3),
                (_ctx.drawerRow.isAppraised)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Đã thẩm định"))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(["ms-auto", `badge badge-light-${_ctx.drawerRow.sentMail ? 'success' : 'secondary'}`]),
                  title: _ctx.drawerRow.sentMail ? 'Đã gửi email phiếu ĐKXT' : 'Chưa gửi email phiếu ĐKXT'
                }, [
                  _hoisted_17,
                  _createTextVNode(_toDisplayString(_ctx.drawerRow.sentMail ? 'Đã gửi email' : 'Chưa gửi email'), 1)
                ], 10, _hoisted_16)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.drawerRow.code || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.drawerRow.phase || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.drawerRow.method || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.arrResource[_ctx.drawerRow.source] ? _ctx.arrResource[_ctx.drawerRow.source].label : (_ctx.drawerRow.source || '—')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.drawerRow.date || '—'), 1)
                  ]),
                  (_ctx.drawerDetail && _ctx.drawerDetail.adRegister && _ctx.drawerDetail.adRegister.updatedAtText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.drawerDetail.adRegister.updatedAtText), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                (_ctx.drawerLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Đang tải…"))
                  : (_ctx.drawerDetail && _ctx.drawerDetail.adMajors && _ctx.drawerDetail.adMajors.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawerDetail.adMajors, (m, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "d-flex align-items-start",
                            key: i
                          }, [
                            _createElementVNode("span", _hoisted_43, _toDisplayString(m.priority || (i + 1)), 1),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _createElementVNode("div", _hoisted_46, _toDisplayString((m.major && m.major.name) || m.name || '—'), 1),
                                (m.averageScore != null && m.averageScore !== '')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(m.averageScore) + " điểm", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_48, [
                                (m.major && m.major.code)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Mã " + _toDisplayString(m.major.code), 1))
                                  : _createCommentVNode("", true),
                                (m.adForm)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, " · Tổ hợp " + _toDisplayString(m.adForm), 1))
                                  : _createCommentVNode("", true),
                                (m.subadform)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, " (" + _toDisplayString(m.subadform) + ")", 1))
                                  : _createCommentVNode("", true),
                                (Number(m.priorityScore) > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, " · ƯT KV/ĐT +" + _toDisplayString(m.priorityScore), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_ctx.arproMajor())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.arproMajor().name), 1),
                              (_ctx.arproMajor().averageScore)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.arproMajor().averageScore) + " điểm", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              (_ctx.arproMajor().code)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Mã " + _toDisplayString(_ctx.arproMajor().code), 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" · Liên thông (LTĐHCQ)")
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_61, "—"))
              ]),
              (_ctx.drawerDetail && _ctx.drawerDetail.adRegister)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _hoisted_64,
                      (_ctx.scoreMethodLabel())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.scoreMethodLabel()), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.hocbaVariantInvalid())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, _hoisted_68))
                      : _createCommentVNode("", true),
                    (_ctx.scoreGroups().length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.scoreGroups(), (g, gi) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: gi,
                            class: "mb-3"
                          }, [
                            (g.title)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(g.title), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_70, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.rows, (r, ri) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass([g.wide ? 'col-12' : 'col-6', "d-flex justify-content-between"]),
                                  key: ri
                                }, [
                                  _createElementVNode("span", _hoisted_71, _toDisplayString(r.label), 1),
                                  _createElementVNode("span", _hoisted_72, _toDisplayString(r.value), 1)
                                ], 2))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_73, "Chưa nhập điểm xét tuyển cho hồ sơ này."))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  (_ctx.dataCustomer && _ctx.dataCustomer.opportunityid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_77, "Đã đẩy · Opportunity"))
                    : (_ctx.dataCustomer && _ctx.dataCustomer.leadid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_78, "Đã đẩy · Lead"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_79, "Chưa đẩy"))
                ]),
                (_ctx.dataCustomer && (_ctx.dataCustomer.leadid || _ctx.dataCustomer.opportunityid))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      (_ctx.dataCustomer.leadid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                            _hoisted_82,
                            _createElementVNode("a", {
                              href: `https://umthcm.lightning.force.com/lightning/r/Lead/${_ctx.dataCustomer.leadid}/view`,
                              target: "_blank",
                              class: "text-primary fw-semibold fs-8 text-break"
                            }, _toDisplayString(_ctx.dataCustomer.leadid), 9, _hoisted_83)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dataCustomer.opportunityid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                            _hoisted_85,
                            _createElementVNode("a", {
                              href: `https://umthcm.lightning.force.com/lightning/r/Opportunity/${_ctx.dataCustomer.opportunityid}/view`,
                              target: "_blank",
                              class: "text-primary fw-semibold fs-8 text-break"
                            }, _toDisplayString(_ctx.dataCustomer.opportunityid), 9, _hoisted_86)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_87,
                _createElementVNode("div", _hoisted_88, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sfMappedFields(), (f, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-6",
                      key: i
                    }, [
                      _createElementVNode("div", _hoisted_89, [
                        _createTextVNode(_toDisplayString(f.label) + " ", 1),
                        _createElementVNode("span", _hoisted_90, "[" + _toDisplayString(f.sf) + "]", 1)
                      ]),
                      _createElementVNode("div", _hoisted_91, _toDisplayString(f.value), 1)
                    ]))
                  }), 128))
                ]),
                (_ctx.dataCustomer && !_ctx.dataCustomer.leadid && !_ctx.dataCustomer.opportunityid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, " Hồ sơ chưa được đẩy lên Salesforce (đẩy khi trạng thái chuyển sang \"Đã xác thực\" / \"Đang xem xét\"). "))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}